import { useState, useEffect } from "react"
import { getCurrentRepo } from "../utils/repo"
import type { RepoName } from "../types"

export function useCurrentRepo(): RepoName | null {
  const [currentRepo, setCurrentRepo] = useState<RepoName | null>(
    getCurrentRepo
  )
  const pathname =
    typeof window !== "undefined" ? window.location.pathname : null

  useEffect(() => {
    setCurrentRepo(getCurrentRepo())
  }, [pathname])

  return currentRepo
}
